import React, { useState, useEffect } from "react";
import "./twilio-start-form.styles.scss";
import axios from "axios";
import { GetHostFromFirebase } from "../../firebase/firebase.utils";

const StartForm = ({
  storeToken,
  storeHostDetails,
  storeRoomDetails,
  storeGuestDetails,
}) => {
  const [name, setName] = useState("");
  const [roomName, setRoomName] = useState("");
  const [hostId, setHostId] = useState("IydtxKTyhaFaJUS4Epsn");

  const handleSubmitHost = async (e) => {
    e.preventDefault();
    const hostName = await GetHostFromFirebase(hostId);
    if (hostName && roomName) {
      setName(hostName);
      storeHostDetails([{ name: hostName, hostId: hostId }]);
      storeRoomDetails(roomName);
      storeGuestDetails([]);
    }
  };

  const handleSubmitGuest = async (e) => {
    e.preventDefault();
    if (name) {
      storeGuestDetails([{ name: name }]);
      storeRoomDetails(roomName);
      storeHostDetails([]);
    }
  };

  useEffect(() => {
    if (name) {
      GetTwilioToken();
    }
  }, [name]);

  const GetTwilioToken = async () => {
    const result = await axios({
      method: "POST",
      url: "https://bittersweet-loris-3249.twil.io/create-token",
      data: {
        identity: name,
      },
    });

    const jwt = result.data;
    storeToken(jwt);
  };

  return (
    <div className="start-form">
      <form className="form" onSubmit={handleSubmitHost}>
        <label htmlFor="host">
          Join as <span style={{ fontWeight: "bold" }}>HOST</span>: <br />
          <input
            type="text"
            id="host"
            name="host"
            placeholder="your host id"
            value={hostId}
            onChange={(e) => setHostId(e.target.value)}
          />
        </label>
        <br />

        <br />
        <label htmlFor="room">
          Room Name: <br />
          <input
            type="text"
            id="room"
            name="room"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
          />
        </label>
        <br />
        <button type="submit">Start room</button>
      </form>

      <div className="divider-line"></div>

      <form className="form" onSubmit={handleSubmitGuest}>
        <label htmlFor="name">
          Join as <span style={{ fontWeight: "bold" }}>GUEST</span>: <br />
          <input
            type="text"
            id="name"
            name="name"
            placeholder="your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        <br />
        <label htmlFor="room">
          Room Name: <br />
          <input
            type="text"
            id="room"
            name="room"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
          />
        </label>
        <br />
        <button type="submit">Join room</button>
      </form>
    </div>
  );
};

export default StartForm;
